import { CarrierModel, ControlProperty, AddressModel } from '../../../../../common';

export class AllocationViewActionCarrierForm {
  constructor(
    model: CarrierModel,
    public address: ControlProperty<AddressModel> = model.address,
    public extId: ControlProperty<string> = model.extId,
    public id: ControlProperty<string> = model.id,
    public name: ControlProperty<string> = model.name,
    // eslint-disable-next-line id-blacklist
    public number: ControlProperty<string> = model.number,
  ) {}
}
